import {
  type SumsubVerificationConfig,
  SumsubVerificationPage,
} from '../SumsubVerificationPage';

const kybConfig: SumsubVerificationConfig = {
  levelName: 'dapp-store-kyb',
  pageTitle: 'Business Verification | Publishing Portal',
  sdkTitle: 'Business Verification',
  verificationType: 'business',
  shouldRedirect: (publisherType) => publisherType === 'Individual',
  redirectPath: '/dashboard/submit-kyc',
};

interface Props {
  className?: string;
}

export function SubmitKybPage(props: Props) {
  return (
    <SumsubVerificationPage className={props.className} config={kybConfig} />
  );
}
